<template>
  <div id="provider_icon_container" class="provider-icon-container">
    <img
      id="artifact_provider_img"
      :src="getIconSrc(provider)"
      width="34"
      class="artifact-provider-img pr-2"
      :style="{ border: artifactTypeColor }"
    />
  </div>
</template>

<script lang="ts" setup>
  import { injectTyped } from '@/inject'
  import { ServiceKeys } from '@/services/symbols'

  defineProps({
    provider: { type: String, required: true, default: '' },
    artifactTypeColor: { type: String, required: true, default: '' },
  })

  const providerIconService = injectTyped(ServiceKeys.providerIcon)
  function getIconSrc(provider: string) {
    return providerIconService.getIconForProvider(provider)
  }
</script>

<style lang="scss" scoped>
  #provider_icon_container.provider-icon-container {
    img {
      border-right-width: 4px;
      border-right-style: solid;
    }
  }
</style>
